import { useContext, createContext } from 'react';

export const EnvironmentSelectorStateContext = createContext();
export const EnvironmentSelectorDispatchContext = createContext();

export const useEnvironmentSelectorStateContext = () => useContext(EnvironmentSelectorStateContext);
export const useEnvironmentSelectorDispatchContext = () =>
  useContext(EnvironmentSelectorDispatchContext);
